import React from 'react';
import { Tooltip } from 'flowbite-react';

interface ProgressBarProps {
	assessmentPending?: number;
	interviewing?: number;
	rejected?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ assessmentPending, interviewing, rejected }) => {
	const total = (assessmentPending ?? 0) + (interviewing ?? 0) + (rejected ?? 0);
	const assessmentPendingPercentage = total > 0 ? ((assessmentPending ?? 0) / total) * 100 : 0;
	const interviewingPercentage = total > 0 ? ((interviewing ?? 0) / total) * 100 : 0;
	const rejectedPercentage = total > 0 ? ((rejected ?? 0) / total) * 100 : 0;

	return (
		<div className="relative h-[15px] bg-gray-200 w-full max-w-[200px]">
			{assessmentPending !== undefined && (
				<Tooltip content={`Assessment Pending`} placement="top">
					<div
						className="flex absolute font-inter text-[12px] justify-center font-[500] leading-[16px] left-0 h-full bg-[#FCCC75]"
						style={{ width: `${assessmentPendingPercentage}%` }}
					>
						{assessmentPending}
					</div>
				</Tooltip>
			)}
			{interviewing !== undefined && (
				<Tooltip content={`Interviewing`} placement="left">
					<div
						className="flex absolute font-inter text-[12px] justify-center font-[500] leading-[16px] left-0 h-full bg-[#57EBA1]"
						style={{ width: `${interviewingPercentage}%`, marginLeft: `${assessmentPendingPercentage}%` }}
					>
						{interviewing}
					</div>
				</Tooltip>
			)}
			{rejected !== undefined && (
				<Tooltip content={`Rejected`} placement="top-end">
					<div
						className="flex absolute font-inter text-[12px] justify-center font-[500] leading-[16px] left-0 h-full bg-[#FF8080]"
						style={{
							width: `${rejectedPercentage}%`,
							marginLeft: `${assessmentPendingPercentage + interviewingPercentage}%`,
						}}
					>
						{rejected}
					</div>
				</Tooltip>
			)}
		</div>
	);
};

export default ProgressBar;
